import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Button from "../../../../components/ui/Button/Button";
import { whyData } from "../../../../data/why";
import "./Why.css";

gsap.registerPlugin(ScrollTrigger);

const Why = () => {
  const sectionRef = useRef(null);
  const leftRef = useRef(null);
  const imageRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Animate left content
      const leftElements = leftRef.current.querySelectorAll(".animate-left");
      gsap.fromTo(
        leftElements,
        { opacity: 0, x: -50, y: 20 },
        {
          opacity: 1,
          x: 0,
          y: 0,
          duration: 0.8,
          stagger: 0.15,
          ease: "power3.out",
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 70%",
            toggleActions: "play none none none",
            once: true,
          },
        },
      );

      // Animate image
      gsap.fromTo(
        imageRef.current,
        { opacity: 0, x: 50, scale: 0.95 },
        {
          opacity: 1,
          x: 0,
          scale: 1,
          duration: 1,
          ease: "power3.out",
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 70%",
            toggleActions: "play none none none",
            once: true,
          },
        },
      );

      // Animate stats if they exist
      const stats = leftRef.current.querySelectorAll(".why-stat");
      if (stats.length > 0) {
        gsap.fromTo(
          stats,
          { opacity: 0, y: 30 },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
            stagger: 0.1,
            ease: "back.out(1.7)",
            scrollTrigger: {
              trigger: stats[0],
              start: "top 85%",
              toggleActions: "play none none none",
              once: true,
            },
          },
        );
      }
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section className="why" ref={sectionRef}>
      <div className="why__container">
        <div className="why__left" ref={leftRef}>
          <div className="why__badge animate-left">{whyData.badge}</div>
          <h2 className="why__headline animate-left">{whyData.headline}</h2>
          <p className="why__description animate-left">{whyData.description}</p>

          {whyData.stats.length > 0 && (
            <div className="why__stats">
              {whyData.stats.map((stat, index) => (
                <div key={index} className="why-stat">
                  <div className="why-stat__number">
                    {stat.number}
                    {stat.suffix}
                  </div>
                  <div className="why-stat__label">{stat.label}</div>
                  {stat.sublabel && (
                    <div className="why-stat__sublabel">{stat.sublabel}</div>
                  )}
                </div>
              ))}
            </div>
          )}

          <div className="animate-left">
            <Button
              text={whyData.ctaButton.text}
              variant="primary"
              link={whyData.ctaButton.link}
            />
          </div>
        </div>

        <div className="why__right">
          <div className="why__image" ref={imageRef}>
            <img src={whyData.image} alt="Why Choose Us" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Why;
